import type { CourierTransaction } from 'common/api/api-types';

import { styled } from 'styled-components';

import { typographyCss } from '@creditornot/cb-ingredients';

import { useNumberFormatter } from 'common/hooks/useNumberFormatter';

import { getAmountToDisplay } from './utils';

const Root = styled.div`
  ${typographyCss.Body3({ weight: 'semiBold' })};
`;
const AggregatedCell: React.FC<{
  value?: CourierTransaction;
  title: string;
}> = ({ value, title }) => {
  const { currency, amount } = value ?? {};
  const numberFormatter = useNumberFormatter();

  return (
    <Root title={title}>
      {getAmountToDisplay({ decimalFormat: numberFormatter?.decimalFormat, amount, currency })}
    </Root>
  );
};

export default AggregatedCell;
